import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logoutHandler, setAuthRes, setUserLoggedIn } from 'redux/auth/auth.action';
import { setValues, removeValues, getValues } from 'services/storage';
import seerbitBoxedLogo from '../../assets/svg/SeerBit boxed Icon SVG.svg';
import { connect } from 'react-redux';
import AppModal from '../organisms/CustomModal';
import SideNav from './SideNav';
import Button from 'components/atoms/Button';
import addSquare from '../../assets/svg/add-square.svg';
import InviteBusiness from 'pages/dashboard/ModalComponents/InviteBusiness';
import { toggleModal } from 'redux/app/app.action';

const MobileNav = ({ logoutHandler, toggleModal }) => {
    const [value, setValue] = useState("");
    const [dropdown, setDropdown] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalId, setModalId] = useState("");


    const navigate = useNavigate()

    const handleOnChange = e => {
        setValue(e.target.value)
    }

    const handleModal = (e) => {
        setModalId(e.target.id)
        setShowModal(prevState => !prevState)
    }

    const modalContent = (
        <AppModal handleClose={handleModal} modalStyle="bg-black w-2/3 min-h-screen z-40 !top-0 left-0 animate-slide_right flex justify-center items-center" contentStyle="h-full w-full absolute top-0 left-0 right-0 relative">
            <SideNav
                setShowModal={setShowModal}
                setModalId={setModalId}
                selectNavItem={() => { }}
                storeCurrentPath={() => { }}
            />
        </AppModal>
    )

    const username = getValues('username')

    return (
        <>
            <span className='flex justify-center w-fit' onClick={e => handleModal(e)}>
                <img src={seerbitBoxedLogo} alt="menu_icon" className='w-8 h-8' id="mainNav" />
            </span>
            <span className='flex justify-center w-3/4'>
                <Button
                    btnType='button'
                    btnText='Invite Business'
                    btnImg={addSquare}
                    btnImgStyle='w-4 h-4'
                    btnStyle='bg-DarkBg3 text-white gap-3 py-2 px-3 flex-row-reverse font-normal text-[15px] w-fit whitespace-nowrap flex-shrink-0'
                    onClick={() => setDropdown(true)}
                />
            </span>
            <span className='flex items-center gap-3 w-fit'>
                <div className='flex flex-shrink-0 justify-center items-center bg-DarkBg3 rounded-full w-8 h-8' onClick={() => navigate('/dashboard/settings')}>
                    <span className='flex-shrink-0 font-bold text-lg leading-4 text-center mx-auto text-SecondaryAccent4'>{username?.slice(0, 2).toUpperCase()}</span>
                </div>
            </span>

            {showModal && modalId === "mainNav" && modalContent}
            {dropdown &&
                <InviteBusiness
                    showModal={dropdown}
                    setShowModal={setDropdown}
                />
            }
        </>
    )
}

const mapDispatchToProps = (dispatch: any) => ({
    logoutHandler: () => dispatch(logoutHandler()),
    toggleModal: (data: boolean) => dispatch(toggleModal(data))
})

export default connect(null, mapDispatchToProps)(MobileNav);